export default [
    { //意见反馈列表
        path: '/feedbackManagement',
        name:'feedbackManagement',
        meta: { title: '意见反馈列表'},
        component: () => import('../../views/feedbackManagement/index.vue')
    },
    { //意见反馈详情
        path: '/feedbackManagement/detail/:id',
        name:'feedbackManagementDetail',
        meta: { title: '意见反馈详情'},
        component: () => import('../../views/feedbackManagement/detail.vue')
    }
]